import React__default from 'react';

const LanguagePickerContext = React__default.createContext(null);
const useLanguagePicker = ({ getItemProps }) => {
    return React__default.useMemo(() => ({
        getItemProps,
    }), [getItemProps]);
};

export { LanguagePickerContext, useLanguagePicker };
